import React, { useState, useEffect } from 'react';
import { TaskDraftDTO, TaskDraftStatus } from '../../types/TaskDraftDTO';
import { taskService } from '../../services/taskService';
import { Table, TableBody, TableCell, TableHead, TableRow, TableContainer, Paper, Button, Box, Typography, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';

interface AdminOrganizationTasksListProps {
    organizationId: string;
}

const AdminOrganizationTasksList: React.FC<AdminOrganizationTasksListProps> = ({ organizationId }) => {
    const [taskDrafts, setTaskDrafts] = useState<TaskDraftDTO[]>([]);
    const [selectedStatus, setSelectedStatus] = useState<string>('ALL');
    const navigate = useNavigate();

    useEffect(() => {
        const fetchTaskDrafts = async () => {
            try {
                const data = await taskService.getTaskDraftsByOrganization(organizationId);
                setTaskDrafts(data);
            } catch (error) {
                console.error('Error fetching task drafts:', error);
            }
        };

        if (organizationId) {
            fetchTaskDrafts();
        }
    }, [organizationId]);

    const handleStatusChange = (event: any) => {
        setSelectedStatus(event.target.value);
    };

    const handleCreateTask = () => {
        // Навигация для создания задачи, если применимо для админа
        console.log("Создать задачу для организации", organizationId);
        // navigate(`/admin/organization/${organizationId}/tasks/create`); // Пример
    };

    const handleViewTaskDraftDetails = (taskDraftId: string) => {
        navigate(`/admin/tasks/${taskDraftId}`); // Навигация на страницу деталей задачи админа
    };

    const filteredTaskDrafts = taskDrafts.filter(task => {
        if (selectedStatus === 'ALL') {
            return true;
        }
        return task.status === selectedStatus;
    });

    const getStatusDisplayName = (status: TaskDraftStatus) => {
        switch (status) {
            case TaskDraftStatus.IN_PROCESS: return 'В процессе';
            case TaskDraftStatus.REJECTED: return 'Отклонено';
            case TaskDraftStatus.FOR_REVISION: return 'На доработку';
            case TaskDraftStatus.READY: return 'Готово';
            case TaskDraftStatus.PAID: return 'Оплачено';
            default: return status;
        }
    };

    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h5" gutterBottom>
                Задачи организации
            </Typography>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <FormControl variant="outlined" sx={{ minWidth: 120 }}>
                    <InputLabel>Статус задания</InputLabel>
                    <Select
                        value={selectedStatus}
                        onChange={handleStatusChange}
                        label="Статус задания"
                    >
                        <MenuItem value="ALL">Все</MenuItem>
                        <MenuItem value="IN_PROCESS">В процессе</MenuItem>
                        <MenuItem value="REJECTED">Отклонено</MenuItem>
                        <MenuItem value="FOR_REVISION">На доработку</MenuItem>
                        <MenuItem value="READY">Готово</MenuItem>
                        <MenuItem value="PAID">Оплачено</MenuItem>
                    </Select>
                </FormControl>
                {/* Кнопка "Создать задачу" может быть добавлена, если это функционал для админа */}
                {/* <Button variant="contained" color="primary" onClick={handleCreateTask}>
                    СОЗДАТЬ ЗАДАЧУ
                </Button> */}
            </Box>

            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Название задания</TableCell>
                            <TableCell>Категории</TableCell>
                            <TableCell>Дедлайн</TableCell>
                            <TableCell>Статус</TableCell>
                            <TableCell>Стоимость</TableCell>
                            <TableCell>Куратор</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredTaskDrafts.map((task) => (
                            <TableRow key={task.id} onClick={() => handleViewTaskDraftDetails(task.id!)} sx={{ cursor: 'pointer' }}>
                                <TableCell>{task.title}</TableCell>
                                <TableCell>{task.taskDraftCategories?.map(tdc => tdc.category?.title).join(', ') || '—'}</TableCell>
                                <TableCell>{task.deadline ? format(new Date(task.deadline), 'dd.MM.yyyy') : '—'}</TableCell>
                                <TableCell>{getStatusDisplayName(task.status!)}</TableCell>
                                <TableCell>{task.priceInKopecks ? `${task.priceInKopecks / 100}₽` : '—'}</TableCell>
                                <TableCell>{task.manager?.fullName || '—'}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default AdminOrganizationTasksList;

